import React, { FC, Fragment, useContext, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Box, FormControl, InputLabel, Select, MenuItem } from '@mui/material';
import { useMutation } from '@apollo/client';
import { updateWaybillPrintFormatTemplate } from 'apollo/templates/organization';
import { AppToasterContext } from 'components/shared/app-toaster/app-toaster-context';
import { LoadingButton } from '@mui/lab';
import { useDenthubErrorBoundary } from 'components/shared/denthub-error-boundary/denthub-error-boundary-context';

type WaybillPrintSettingsProps = {
    currentPrintFormat: string;
};
const WaybillPrintSettings: FC<WaybillPrintSettingsProps> = ({ currentPrintFormat }: WaybillPrintSettingsProps) => {
    const { t: translate } = useTranslation(['lab-settings']);
    const { showBoundary } = useDenthubErrorBoundary();
    const { setAppToasterContent } = useContext(AppToasterContext);
    const [printFormat, setPrintFormat] = useState<string>(currentPrintFormat);

    const [updateWaybillPrintFormat, { loading: saveLoading }] = useMutation(updateWaybillPrintFormatTemplate, {
        onError: (error) => {
            showBoundary(error);
        },
        onCompleted: () => {
            setAppToasterContent({
                isOpen: true,
                severity: 'success',
                message: translate('common:CHANGES_SAVED'),
            });
        },
    });

    useEffect(() => {
        setPrintFormat(currentPrintFormat);
    }, [currentPrintFormat]);

    const handleChangePrintFormat = (newFormat: string) => {
        setPrintFormat(newFormat || '');
    };

    const handleSaveChanges = () => {
        updateWaybillPrintFormat({
            variables: {
                printFormat,
            },
        });
    };

    return (
        <Fragment>
            <FormControl fullWidth>
                <InputLabel id="waybill-print-label">{translate('lab-settings:WAYBILL_PRINT')}</InputLabel>
                <Select
                    labelId="waybill-print-label"
                    value={printFormat}
                    label={translate('lab-settings:WAYBILL_PRINT')}
                    onChange={(event) => handleChangePrintFormat(event.target.value)}
                >
                    <MenuItem value=""></MenuItem>
                    <MenuItem value="laser-ste">{translate('lab-settings:WAYBILL_LASER_STE')}</MenuItem>
                    <MenuItem value="thermo-se">{translate('lab-settings:WAYBILL_THERMO_SE')}</MenuItem>
                    <MenuItem value="thermo-190">{translate('lab-settings:WAYBILL_THERMO_190')}</MenuItem>
                    <MenuItem value="thermo-brev3">{translate('lab-settings:WAYBILL_THERMO_LETTER')}</MenuItem>
                </Select>
            </FormControl>
            <Box mt={1}>
                <LoadingButton loading={saveLoading} onClick={handleSaveChanges}>
                    {translate('lab-settings:SAVE_CHANGES')}
                </LoadingButton>
            </Box>
        </Fragment>
    );
};

export default WaybillPrintSettings;
